// extracted by mini-css-extract-plugin
export default {"heading":"HeaderContainer_heading__zFEFx","headercontainer":"HeaderContainer_headercontainer__MY4de"};